import { ApolloClient } from '@apollo/client';
import { useWeb3React } from '@web3-react/core';
import { getKiwiClient, getNFTClient, getNFTClient1155, getNonStandardNFTClient } from '../../services/apollo';
import { useEffect, useState } from 'react';

export const useNFTClient = (): ApolloClient<unknown> => {
  const { chainId } = useWeb3React();
  const [client, setClient] = useState(getNFTClient(chainId || 1));

  useEffect((): void => {
    setClient(getNFTClient(chainId || 1));
  }, [chainId]);

  return client;
};

export const useNFTClient1155 = (): ApolloClient<unknown> => {
  const { chainId } = useWeb3React();
  const [client, setClient] = useState(getNFTClient1155(chainId || 1));

  useEffect((): void => {
    setClient(getNFTClient1155(chainId || 1));
  }, [chainId]);

  return client;
};

export const useNonStandardNFTClient = (): ApolloClient<unknown> => {
  const { chainId } = useWeb3React();
  const [client, setClient] = useState(getNonStandardNFTClient(chainId || 1));

  useEffect((): void => {
    setClient(getNonStandardNFTClient(chainId || 1));
  }, [chainId]);

  return client;
};

export const useKiwiClient = (): ApolloClient<unknown> => {
  const { chainId } = useWeb3React();
  const [client, setClient] = useState(getKiwiClient(chainId || 1));

  useEffect((): void => {
    setClient(getKiwiClient(chainId || 1));
  }, [chainId]);

  return client;
};
